class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
          const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      cartDrawerItems.updateCartUpsellVisibility();
    }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  // Enfin Libre 10 sept. 2026 (A) : tiroir optimiste. Insère une ligne provisoire complète (vignette, titre, variante, prix,
  // quantité) et met à jour compteur d'en-tête et total côté client, puis ouvre le tiroir immédiatement ; renderContents()
  // remplace ensuite .drawer__inner par le rendu serveur. hideOptimistic(true) restaure tout en cas d'erreur.
  _parseMoney(text) {
    const m = String(text || '').match(/-?\d[\d\s.,  ]*/);
    if (!m) return null;
    let n = m[0].replace(/[\s  ]/g, '');
    const lastComma = n.lastIndexOf(','), lastDot = n.lastIndexOf('.');
    const dec = lastComma > lastDot ? ',' : (lastDot > -1 ? '.' : '');
    if (dec) { const [int, frac] = [n.slice(0, n.lastIndexOf(dec)), n.slice(n.lastIndexOf(dec) + 1)]; n = int.replace(/[.,]/g, '') + '.' + frac; } else n = n.replace(/[.,]/g, '');
    const v = parseFloat(n); return isNaN(v) ? null : v;
  }
  _formatMoneyLike(template, value) {
    const m = String(template || '').match(/-?\d[\d\s.,  ]*/);
    if (!m) return null;
    const token = m[0].replace(/[\s  ]+$/, ''); // sans l'espace qui précède « € »
    const sample = token.replace(/[\s  ]/g, '');
    const lastComma = sample.lastIndexOf(','), lastDot = sample.lastIndexOf('.');
    const dec = lastComma > lastDot ? ',' : (lastDot > -1 ? '.' : ',');
    const decimals = (dec && Math.max(lastComma, lastDot) > -1) ? sample.length - Math.max(lastComma, lastDot) - 1 : 2;
    const fixed = value.toFixed(decimals);
    const [int, frac] = fixed.split('.');
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? ' ' : ',');
    return String(template).replace(token, frac !== undefined ? grouped + dec + frac : grouped);
  }
  showOptimistic(line) {
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;
    this.hideOptimistic(false);
    this._optimisticWasEmpty = this.classList.contains('is-empty') || inner.classList.contains('is-empty');
    this.classList.remove('is-empty');
    inner.classList.remove('is-empty');
    const items = this.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    const emptyBlock = inner.querySelector('.drawer__inner-empty');
    if (emptyBlock) { this._optimisticEmptyEl = emptyBlock; emptyBlock.style.display = 'none'; }
    const qty = Math.max(1, parseInt(line.quantity, 10) || 1);
    const unit = this._parseMoney(line.price);
    // compteur d'en-tête « Votre panier – N »
    const heading = this.querySelector('.drawer__heading');
    if (heading && /\d+\s*$/.test(heading.textContent)) {
      this._optimisticHeading = heading.textContent;
      heading.textContent = heading.textContent.replace(/(\d+)(\s*)$/, (all, n, sp) => String(parseInt(n, 10) + qty) + sp);
    }
    // total
    const totalEl = this.querySelector('.totals__total-value');
    if (totalEl && unit !== null) {
      this._optimisticTotal = totalEl.textContent;
      const current = this._parseMoney(totalEl.textContent) || 0;
      const formatted = this._formatMoneyLike(totalEl.textContent, current + unit * qty);
      if (formatted) totalEl.textContent = formatted;
    }
    const contents = this.querySelector('#CartDrawer-CartItems') || inner;
    const wrap = document.createElement('div');
    wrap.className = 'drawer__cart-items-wrapper cart-drawer__optimistic';
    wrap.setAttribute('aria-busy', 'true');
    wrap.innerHTML =
      '<table class="cart-items" role="table"><tbody role="rowgroup"><tr class="cart-item" role="row">' +
      '<td class="cart-item__media" role="cell"></td>' +
      '<td class="cart-item__details" role="cell"><span class="cart-item__name h4 break"></span>' +
      '<div class="lm-line-price"><span class="lm-line-price__final"></span></div><dl><div class="product-option"><dd></dd></div></dl></td>' +
      '<td class="cart-item__quantity" role="cell"><div class="cart-item__quantity-wrapper"><quantity-input class="quantity cart-quantity">' +
      '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
      '<input class="quantity__input" type="number" disabled aria-label="Quantité">' +
      '<button class="quantity__button" type="button" disabled aria-hidden="true">+</button></quantity-input></div></td>' +
      '</tr></tbody></table>';
    if (line.image) {
      const img = document.createElement('img');
      img.className = 'cart-item__image'; img.src = line.image; img.alt = ''; img.width = 150; img.height = 150;
      wrap.querySelector('.cart-item__media').appendChild(img);
    }
    wrap.querySelector('.cart-item__name').textContent = line.title || '';
    wrap.querySelector('.lm-line-price__final').textContent = (unit !== null && qty > 1 && this._formatMoneyLike(line.price, unit * qty)) || line.price || '';
    const dd = wrap.querySelector('.product-option dd');
    if (line.variant) dd.textContent = line.variant; else dd.closest('dl').remove();
    wrap.querySelector('.quantity__input').value = qty;
    contents.prepend(wrap);
    this.open();
  }

  hideOptimistic(restoreEmpty) {
    this.querySelectorAll('.cart-drawer__optimistic').forEach((el) => el.remove());
    if (this._optimisticEmptyEl) { this._optimisticEmptyEl.style.display = ''; this._optimisticEmptyEl = null; }
    if (restoreEmpty) {
      const heading = this.querySelector('.drawer__heading');
      if (heading && this._optimisticHeading) heading.textContent = this._optimisticHeading;
      const totalEl = this.querySelector('.totals__total-value');
      if (totalEl && this._optimisticTotal) totalEl.textContent = this._optimisticTotal;
      if (this._optimisticWasEmpty) {
        this.classList.add('is-empty');
        const inner = this.querySelector('.drawer__inner');
        if (inner) inner.classList.add('is-empty');
        const items = this.querySelector('cart-drawer-items');
        if (items) items.classList.add('is-empty');
        this.close();
      }
    }
    this._optimisticHeading = null; this._optimisticTotal = null; this._optimisticWasEmpty = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
